import { createStore,applyMiddleware,combineReducers} from "redux";
import {formStateReducer} from '../Reducers/FormStateReducers'
//import { AppReducer } from "../Reducers/AppReducer";

const devTools =
  process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__({
        trace: false,
        maxAge: 5
      })
    : undefined;

export const formStateStore = createStore(
    formStateReducer, devTools);

/*formStateStore.subscribe(()=>{
    // console.log('subscribe formState :: ',formStateStore.getState());
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
})*/